import { useState } from "react"
import { Heading, Input, RadionButtonGroup, Section } from "../../page"
import { sendBonusCode, SendCodeResponse, sendCypherCode } from "../../../api"
import { useAction, useAppState } from "../../../hooks"
import { EInfoMessageType } from "../../../types"

import './code.scss'
import { GAMES, gameType } from "../../../utils"

type CodeProps = {
    setLoading: any,
    refreshUser: any,
    selectedAction: string,
    setSelectedAction: any
}

export const Code = ({ setLoading, refreshUser, selectedAction, setSelectedAction }: CodeProps) => {
    const [code, setCode] = useState('')
    const [codeError, setCodeError] = useState('')
    const { state } = useAppState()
    const { setInfoMessageAction } = useAction()

    const sendNewCode = () => {
        if (state?.token) {
            setLoading(true)
            switch (selectedAction) {
                case 'CYPHER':
                    callSendNewCode(state.token, sendCypherCode, 'Vyplňte jméno šifry!')
                    break
                case 'BONUS':
                    callSendNewCode(state.token, sendBonusCode, 'Vyplňte bonusové heslo!')
                    break
            }
        }
    }

    const callSendNewCode = (token: string, sendFunction: (SendCodeProps: any) => Promise<SendCodeResponse>, emptyMessage: string) => {
        if (code.length < 1) {
            setCodeError(emptyMessage)
            setLoading(false)
            return
        }
        sendFunction({ code: code, token: token }).then((res) => {
            console.log(res)
            if (res.sucessMessage) {
                setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: res.sucessMessage, timeout: 60 })
                refreshUser()
            } else if (res.errorMessage) {
                console.log('ERROR')
                console.log(res.errorMessage)
                setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage, timeout: 20 })
                setLoading(false)
            }
        })
    }

    const CodeType = () => {

        if (gameType() === GAMES.SIFT) {
            return <div>Jméno šifry:</div>
        }

        return (
            <div className='newCode__code-type__radio'>
                <RadionButtonGroup
                    radioButtons={[{ label: "Příchod na šifru", value: "CYPHER" }, { label: "Bonusové heslo", value: "BONUS" }]}
                    name="CodeAction"
                    selectedValue={selectedAction}
                    setValue={setSelectedAction}
                />
            </div>
        )
    }


    return (
        <>
            <Heading headline='Zadat jméno šifry' weight={2} centered={true} />
            <Section delimeter={true}>
                Po příchodu na novou šifru nezapomeňte co nejdříve zadat její jméno.
                <div className='newCode'>
                    <div className='newCode__code'>
                       <div className='newCode__code-type'>
                            <CodeType/>
                        </div>
                        <div className='newCode__code-input'>
                            <Input
                                label=''
                                value={code}
                                setValue={e => setCode(e.target.value)}
                                errorMessage={codeError}
                                type='text'
                            />
                        </div>
                    </div>
                    <div className='newCode__send'>
                        <button className='button' onClick={sendNewCode}> Odeslat</button>
                    </div>
                </div>
            </Section>
        </>
    )
}